export default __webpack_public_path__ + "static/media/review_top_bg.71f86c7a.png";